import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { Box } from '@miro-site/core';
import { Hero } from '@miro-site/components_hero';
import { RelatedContent } from '@miro-site/components_related-content';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Cards = styled(Box).attrs({
  $styles: {
    backgroundImage: ["url('https://images.ctfassets.net/w6r2i5d8q73s/5FTaMmrjHZLhrxtVQKP9Lm/339c97cbdfe54578c8379dc433f43810/404-bg-vertical.svg')", "url('https://images.ctfassets.net/w6r2i5d8q73s/6zibS8u2Dcw9X6aMyT7tKt/913eae16ee4e064df6be0649f3037cb1/404-bg.svg')"],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left top',
    backgroundSize: 'cover',
    backgroundPositionY: ['25px', '0%']
  }
}).withConfig({
  displayName: "PageNotFound__Cards",
  componentId: "sc-1p232y3-0"
})([""]);

var PageNotFound = function PageNotFound() {
  var heroProps = {
    headline: {
      text: 'Hmm, that didn’t work'
    },
    content: {
      html: 'That page can’t be reached, but if you double-check it,<br/>we’re happy to try again.'
    },
    button: {
      text: '← Back to Homepage',
      href: '/',
      arrow: false
    },
    background: 'transparent'
  };
  var cardProps = {
    arrow: true,
    grid: {
      columns: 3
    },
    headline: {
      text: '',
      align: 'center'
    },
    items: [{
      headline: {
        text: 'Miro App',
        tag: 'h3',
        size: 'small'
      },
      content: {
        html: 'Co-create wherever you and your teams work.'
      },
      link: {
        href: '/app/'
      }
    }, {
      headline: {
        text: 'Help Center',
        tag: 'h3',
        size: 'small'
      },
      content: {
        html: 'Get answers to any questions you might have.'
      },
      link: {
        href: '//help.miro.com'
      }
    }, {
      headline: {
        text: 'Miro Status',
        tag: 'h3',
        size: 'small'
      },
      content: {
        html: 'Check out real-time status updates.'
      },
      link: {
        href: '//status.miro.com'
      }
    }]
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Hero, _objectSpread({}, heroProps)), /*#__PURE__*/_jsx(Cards, {
      children: /*#__PURE__*/_jsx(RelatedContent, _objectSpread({}, cardProps))
    })]
  });
};

export default PageNotFound;